/**
 * RouteToastCleaner — 페이지(pathname)가 바뀌면 이전 화면의 토스트를 정리한다.
 *
 * App.js에서 <Router> 안에 한 번만 마운트한다. Toast.js는 라우터를 모르므로(테스트 격리),
 * 라우터 접근은 이 얇은 컴포넌트가 맡는다.
 *
 * 남기는 것
 *   - persistAcrossRoute 옵션으로 띄운 토스트
 *   - 이동 직전 ROUTE_CHANGE_TOAST_GRACE_MS 안에 띄운 토스트 ("저장했어요" → navigate 흐름은 새 화면에서 읽혀야 한다)
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useToast } from '../Toast';

export const ROUTE_CHANGE_TOAST_GRACE_MS = 800;

const RouteToastCleaner = () => {
  const { pathname } = useLocation();
  const { clearToasts } = useToast();
  const previousPathRef = useRef(pathname);

  useEffect(() => {
    if (previousPathRef.current === pathname) return;
    previousPathRef.current = pathname;
    clearToasts({ keepNewerThanMs: ROUTE_CHANGE_TOAST_GRACE_MS });
  }, [clearToasts, pathname]);

  return null;
};

export default RouteToastCleaner;
